import {jwtDecode} from "jwt-decode";

// Controleer of de gebruiker toegang heeft tot een specifieke walletCode
export const hasAccessToDashboard = (token, walletCode) => {
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    return decoded.dashboards?.includes(walletCode);
  } catch (error) {
    console.error("Invalid token", error);
    return false;
  }
};
